module.exports = __webpack_public_path__ + "img/norway-breast-cancer-female.02dc6385.png";